import type { TabListProps as MuiTabListProps } from '@mui/lab/TabList';

import MuiTabList from '@mui/lab/TabList';
import React from 'react';

export interface TabsListProps extends MuiTabListProps {
  allowScrollButtonsMobile?: boolean;
  visibleScrollbar?: boolean;
  /**
   * Indicates a value required by aria-label for tab list.
   */
  label?: string;
  /**
   * Centers the tab buttons. `variant="scrollable"` ignores MUI's own
   * `centered` prop, so this centers the flex container directly instead.
   */
  centered?: boolean;
}

const TabsList = ({
  allowScrollButtonsMobile,
  centered,
  children,
  label,
  visibleScrollbar,
}: TabsListProps) => {
  return (
    <MuiTabList
      allowScrollButtonsMobile={allowScrollButtonsMobile}
      visibleScrollbar={visibleScrollbar}
      variant="scrollable"
      aria-label={label}
      sx={
        centered
          ? { '& .MuiTabs-flexContainer': { justifyContent: 'center' } }
          : undefined
      }
    >
      {children}
    </MuiTabList>
  );
};
export default React.memo(TabsList);
